import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { providePrimeNG } from 'primeng/config';
import MyPreset from '../theme/theme';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './@interceptors/auth-interceptor';
import { MessageService } from 'primeng/api';
import { errorInterceptor } from './@interceptors/error-interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { toastInterceptor } from './@interceptors/toast-interceptor';
import { spinnerInterceptor } from './@interceptors/spinner-interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor, toastInterceptor, spinnerInterceptor]), withFetch()),
    provideRouter(routes),
    provideAnimations(),
    MessageService,
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: '.app-dark'
        }
      }
    })
  ]
};
